import { useEffect } from "react";
import { Loader } from "components/UI/atoms";
import { useAppContext } from "context/app-context";
import { useNavigate } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";

export const DeviceVerificationGuardRouter = ({ children }) => {
  const { sessionInfo } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionInfo) return;

    if (sessionInfo.isLoggedIn && !sessionInfo.isDeviceVerified)
      navigate(INTERNAL_PATHS.DEVICE_VERIFICATION_NEW);
  }, [sessionInfo, navigate]);

  if (!sessionInfo || sessionInfo.isInitialLoading) {
    return <Loader variant="secondary" id="page-loader" />;
  }

  return children;
};
